import { urlBuilder } from "@42.nl/react-url";
import { InfoTooltip, JarbSelect } from "@42.nl/ui";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "@services/api/requests.service";
import { Loader } from "../components";
import { ReferenceType } from "./Reference";

type Props = {
  id: string;
  year?: string;
  label: string;
  placeholder: string;
  tooltip?: string;
  validator: string;
};

export function getReferenceTypes(year?: string): Promise<string[]> {
  const url = urlBuilder({
    url: "/api/references/types",
    queryParams: {
      year
    }
  });
  return getRequest(url);
}

export default function ReferenceTypeSelect({
  id,
  year,
  label,
  placeholder,
  tooltip,
  validator
}: Readonly<Props>) {
  const state = useQuery({
    queryKey: [ReferenceType.QUERY_KEY_ALL, year],
    queryFn: () => getReferenceTypes(year)
  });

  return (
    <Loader state={state}>
      {(types) => (
        <JarbSelect
          id={id}
          name={id}
          label={
            <>
              <span>{label}</span>
              <InfoTooltip tooltip={tooltip} />
            </>
          }
          placeholder={placeholder}
          options={types.sort()}
          labelForOption={(type) => type}
          jarb={{
            validator,
            label
          }}
        />
      )}
    </Loader>
  );
}
